
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getCheckList } from '@/api/orderPolling';

@Component({
    name: 'selectCheck',
    components: {

    }
})
export default class extends Vue {
    @Prop({
    type: Boolean,
    default: false
    })dialogSelectCheckVisible!:Boolean;

    private formSearchEventCheck = {
    name: '',
  
    }
    private dataList:any = []
    private selectCheck: any = ''
    private pageQuery = {
    pageCurrent: 1,
    pageSize: 10
    }
    private moreLoading = false

    created() {
    this.getCheckList();
    }

    private tableRowChildSection() {
    return 'bgColor';
    }
    private search() {
    this.pageQuery.pageCurrent = 1;
    this.selectCheck = '';
    this.getCheckList();
    }
    private reset() {
    this.formSearchEventCheck = { name: '' };
    this.pageQuery.pageCurrent = 1;
    this.getCheckList();
    }
    // 选择自定义事件
    private getCheckList() {
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    parmars.page = this.pageQuery.pageCurrent;
    parmars.size = this.pageQuery.pageSize;
    parmars.check_name = this.formSearchEventCheck.name;
    getCheckList(parmars).then(res => {
        if (res.data && res.data.page_count > 1 && res.data.page_current < res.data.page_count) {
        this.moreLoading = true;
        } else {
        this.moreLoading = false;
        }

        if (res.data) {
        if (this.pageQuery.pageCurrent === 1) {
            this.dataList = res.data.list;
        } else {
            this.dataList = this.dataList.concat(res.data.list);
        }
        } else {
        this.dataList = [];
        }
    }).catch(err => {
        let msg = err;
    });
    }

    private loadMore() {
    this.pageQuery.pageCurrent++;
    this.getCheckList();
    }

    private selectCheckFinsh() {
    if (this.selectCheck === '') {
        this.$notify({
        title: '提示',
        message: '请选择检查项',
        offset: 100,
        type: 'error'
        });
        return;
    }
    this.$emit('selectCheck', this.selectCheck);
    this.close();
    }

    private close() {
    this.$emit('close', false);
    }
}

